module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('backhaul-dashboard', {
    attrs: {
      "org-id": _vm.org().id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b970c3f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BackhaulView.vue
// module id = 1698
// module chunks = 0